<template>
  <!-- ////////// SECTION HOME ////////// -->
  <section id="home">
    <img class="cloud front-cloud" src="../assets/cloud1.png" alt="Cloud" />
    <img class="cloud back-cloud" src="../assets/cloud2.png" alt="Cloud" />
    <img class="cloud sheep-cloud" src="../assets/sheep.png" alt="Sheep Cloud" />

    <header>
      <img class="dave-logo" src="../assets/web-dev-dave.png" alt="Web Dev Dave" />
    </header>

    <main class="home">
      <div class="intro">
        <p class="hello">Oh, hello dere!</p>
        <p class="dave"><span class="imdave">I'm Dave...</span> I <i class="fas fa-heart"></i> making websites</p>
        <p class="welcome">welcome to my little corner of the web!</p>
        <p class="showcase">
          I developed this site to showcase some of my dev &amp; design, as well as give a little background about
          myself...
        </p>
        
        <a id="tab" href="#about"><!-- TAB HERE --></a>
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: "Intro",
  props: {
    // msg: String
  },
  data() {
    return {
      title: "My first title, woo!"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
//IMPORTS ////////////////////
@import url("../styles/partials/_clouds.scss");

//HOMEPAGE //////////////////
section#home {
  background: url("../assets/sky.png") no-repeat top left,
    linear-gradient(
      rgb(255, 255, 255) 0,
      rgb(225, 225, 225) 600px,
      rgb(226, 226, 226) 100%
    );
  @include phone-down {
    background: url("../assets/sky.png") no-repeat top left / 60% auto,
      linear-gradient(
        rgb(255, 255, 255) 0,
        rgb(225, 225, 225) 320px,
        rgb(226, 226, 226) 100%
      );
  }
  position: fixed;
  top: 0;
  left: 0;
}

// DAVE MAIN LOGO
.dave-logo {
  margin: 0 auto;
  @include tablet-down {
    max-width: 85%;
  }
  @include phone-down {
    max-width: 100%;
  }
}

main.home {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  padding: 0;
  padding-bottom: 25%;
  @include xl-up {
    padding-bottom: 10%;
  }
  @include tablet-down {
    // padding: 0;
    padding-bottom: 30%;
    width: 75%;
  }
  @include phone-down {
    padding-bottom: 40%;
  }
  .intro {
    //
    @include tablet-down {
      //
    }
    @include phone-down {
      //
    }
    p {
      font-family: "Oswald", sans-serif;
      font-size: 2rem;
      line-height: 1.2;
      color: #b3b3b3;
      margin-bottom: 0;
      @include phone-down {
        text-align: center !important;
      }
    }
    .hello {
      font-size: 6.25rem;
      padding-bottom: 20px;
      white-space: nowrap;
      @include tablet-down {
        font-size: 5.5vw;
        padding-bottom: 12px;
      }
      @include phone-down {
        font-size: 6vw;
        padding-bottom: 20px;
      }
    }
    .dave {
      .imdave {
        font-size: 5rem;
        @include tablet-down {
          font-size: 5.2vw;
        }
        @include phone-down {
          font-size: 8vw;
          display: block;
        }
      }
      .fa-heart {
        color: #cf6264;
      }
      font-size: 7.7rem;
      text-align: right;
      white-space: nowrap;
      @include tablet-down {
        font-size: 7vw;
      }
      @include phone-down {
        font-size: 8vw;
        line-height: 1.1;
      }
    }
    .welcome {
      font-size: 4.2rem;
      text-align: right;
      line-height: 1;
      @include tablet-down {
        padding-top: 0;
        font-size: 3.8vw;
      }
      @include phone-down {
        padding-top: 23px;
        font-size: 5.5vw;
      }
    }
    .showcase {
      font-size: 3.5rem;
      text-align: right;
      padding-top: 30px;
      @include tablet-down {
        font-size: 3.5vw;
      }
      @include phone-down {
        font-size: 4.95vw;
      }
    }
    #tab {
      display: block;
      width: 90%;
      height: 62px;
      background-image: url("../assets/tab.png");
      background-position: right center;
      background-repeat: no-repeat;
      margin: 40px auto 0 auto;
      cursor: pointer;
      transition: transform 0.25s ease;
    }

    #tab:hover {
      background-image: url("../assets/tab-over.png");
      transform: translateY(+10px);
    }
  }
}
</style>
